import defaultAttributes from '../defaultAttributes';

const SidebarOpen = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z',
      },
    ],
    ['path', { d: 'M9 3v18' }],
    ['path', { d: 'M14 9l3 3-3 3' }],
  ],
];

export default SidebarOpen;
